import React, { Component } from 'react';
import {Helmet} from 'react-helmet'
import '../../common/index.scss';
import {connect} from "react-redux";
import {Link} from 'react-router-dom';

import {addToCart} from '../../../actions'
import AuthService from "../../services/auth.service";
import ApiService from "../../services/api.service";
import CampaignService from "../../services/campaign.service";
import { getFromPurchaseRefered,getFromCartUser} from '../../../actions'
import store from '../../../store';
import Swal from 'sweetalert2';
import CategGridProductList from '../common/list-grid-product';

class CampaignView extends Component {

    constructor(props){
        super(props);
        this.handlerAddCart = this.handlerAddCart.bind(this);
        this.state = {
            open: false,
            results_product: [],
            campaignData: null,
            dataCategoria: {
                color: '#ff6347',
                text_color: '#ffffff',
                name: 'Campaña'
            },
            isLoading: false,
            user_name: '',
            alias: '',
        }
    }

    componentWillMount() {
        var user = AuthService.getCurrentUser();
        if(user)
        {
            this.setState({
                user_name: user.name,
                alias: user.alias,
            });
            document.body.classList.add('dark');
            document.body.style = `background-color: #161616;font-family: 'Work Sans'`;
            this.checkOpen();
        }else{
            this.props.history.push("/login");
        }
    }

    checkOpen(){
        var user = AuthService.getCurrentUser();
        ApiService.checkOpen(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    if(res.data.option_value == 'NO')
                    {
                        if(window.location.pathname != '/closed')
                        {
                            this.props.history.push("/closed")
                        }
                    }else{
                        this.getCampaignData();
                        this.getRefOrders();
                    }
                }else{
                    this.props.history.push("/closed")
                    window.location.reload();
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    getCampaignData(){
        const campaign_uid = this.props.match.params.uid;
        if (!campaign_uid) {
            this.props.history.push("/welcome");
            return;
        }

        document.getElementsByClassName("page-loader")[0].style.display = "flex";
        this.setState({ isLoading: true });

        CampaignService.getCampaignByUid(campaign_uid).then(
            (res) => {
                if (res && res.status === 'success' && res.data) {
                    this.setState({
                        campaignData: res.data,
                        results_product: res.data.products || []
                    });

                    if (res.data.products && res.data.products.length === 0) {
                        document.getElementsByClassName("page-loader")[0].style.display = "none";
                    } else {
                        setTimeout(() => {
                            document.getElementsByClassName("page-loader")[0].style.display = "none";
                            this.setState({ isLoading: false });
                        }, 1000);
                    }
                } else {
                    Swal.fire({
                        showConfirmButton: false,
                        type: 'warning',
                        title: 'Campaña no encontrada',
                        html: 'La campaña no está disponible',
                    });
                    document.getElementsByClassName("page-loader")[0].style.display = "none";
                    this.props.history.push("/welcome");
                }
            },
            error => {
                document.getElementsByClassName("page-loader")[0].style.display = "none";
                this.setState({ isLoading: false });
                this.props.history.push("/welcome");
            }
        );
    }

    getRefOrders(){
        var user = AuthService.getCurrentUser();
        ApiService.getReferredOrders(user.token, user.token_order, user.id).then(
            (res) => {
                if(res && res.status == 'success'){
                    store.dispatch(getFromPurchaseRefered(res.data));
                    if (res.carts_data && res.carts_data.length === 0) {
                        localStorage.removeItem('hasCheckedOpen');
                    }
                    store.dispatch(getFromCartUser(res.carts_data));
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    handlerAddCart(item,quantity, redirect) {
        if(item && quantity > 0){
            var user = AuthService.getCurrentUser();
            const campaign_uid = this.props.match.params.uid;

            let data_cart = {
                'token': user.token_order,
                'id_user': user.id,
                'id_product': item.id,
                'quantity': quantity,
                'price': item.price,
                'campaign_uid': campaign_uid || null,
            }
            ApiService.postItemToCart(user.token,data_cart).then(
                (res) => {
                    if(res && res.status == 'success'){

                        store.dispatch(addToCart(res.data, quantity))

                        document.getElementById("addCart-overlay").style.display = "block";
                        setTimeout(this.openAddCartCorrectly(redirect, this.props), 1000);

                    }else{
                        if(res.mensajeError)
                        {
                            Swal.fire({
                                showConfirmButton: false,
                                type: 'warning',
                                title: 'Aviso!',
                                html: res.mensajeError,
                            });
                        }else if(res.message){
                            Swal.fire({
                                showConfirmButton: false,
                                type: 'warning',
                                title: 'Aviso!',
                                html: res.message,
                            });
                        }
                    }

                },
                error => {
                  const resMessage =
                    (error.response &&
                      error.response.data &&
                      error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
              );
        }
    }

    openAddCartCorrectly(redirect, propsRuta) {
        setTimeout(function() {
            try {
                document.getElementById("addCart-overlay").style.display = "none";
            } catch (error) {

            }
            if(redirect){
                propsRuta.history.push( (AuthService.getCurrentUser() && AuthService.getCurrentUser().role ? (AuthService.getCurrentUser().role == 'REFERIDO' ? '/cart' : '/user-checkout') : '/cart') )
            }
        }, 1500);
    }

	closeAddCartCorrectly() {
		document.getElementById("addCart-overlay").style.display = "none";
	}

    renderResults() {
        const { symbol, addToCart, addToWishlist, addToCompare } = this.props;

        if (this.state.results_product.length === 0) {
            return null;
        }

        // Agrupar los productos de dos en dos
        const groupedProducts = [];
        for (let i = 0; i < this.state.results_product.length; i += 2) {
            groupedProducts.push(this.state.results_product.slice(i, i + 2));
        }

        return (
            <>
                <section className="section_list_categ_products" style={{ padding: '20px 0', marginTop: '20px' }}>
                    {groupedProducts.map((productGroup, index) => (
                        <div key={index}>
                            <CategGridProductList
                                products={productGroup}
                                symbol={symbol || "S/. "}
                                categoria={this.state.dataCategoria}
                                handlerAddCart={this.handlerAddCart}
                                onAddToCompareClicked={(product) => addToCompare && addToCompare(product)}
                                onAddToWishlistClicked={(product) => addToWishlist && addToWishlist(product)}
                                onAddToCartClicked={(product, quantity) => addToCart && addToCart(product, quantity)}
                                key={index}
                                indice={index + 1}
                                cant_categ={this.state.results_product.length}
                            />
                        </div>
                    ))}
                </section>
            </>
        );
    }

    componentDidMount() {
        document.getElementById("color").setAttribute("href", `${process.env.PUBLIC_URL}/assets/css/color3.css` );
    }

    render() {
        const {results_product, campaignData} = this.state;
        const campaignName = campaignData && campaignData.campaign ? campaignData.campaign.campaign_name : 'Campaña';

        return (
            <div className="sup-content-welcome">
                <Helmet>
                    <title>{campaignName}</title>
                </Helmet>

                <div className="container container-welcome campaign-container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    {campaignData && (
                        <>
                            {/* Banner de campaña */}
                            {campaignData.banner && campaignData.banner.image && (
                                <div className="campaign-banner-header" style={{
                                    marginBottom: '30px',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                }}>
                                    <img
                                        src={campaignData.banner.image}
                                        alt={campaignData.banner.name || campaignData.campaign.campaign_name}
                                        style={{
                                            width: '100%',
                                            maxHeight: '400px',
                                            objectFit: 'cover',
                                            display: 'block'
                                        }}
                                    />
                                </div>
                            )}

                            {/* Información de campaña */}
                            <div className="campaign-header text-center" style={{
                                padding: '30px 20px',
                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                borderRadius: '12px',
                                marginBottom: '40px'
                            }}>
                                <h2 style={{
                                    color: '#fff',
                                    fontSize: '32px',
                                    marginBottom: '15px',
                                    fontWeight: 'bold'
                                }}>
                                    {campaignData.campaign.campaign_name}
                                </h2>
                                {campaignData.campaign.discount_percentage > 0 && (
                                    <h3 style={{
                                        color: '#28a745',
                                        fontSize: '24px',
                                        margin: '15px 0'
                                    }}>
                                        {campaignData.campaign.discount_percentage}% de descuento
                                    </h3>
                                )}
                                {campaignData.campaign.active_until && (
                                    <p style={{
                                        color: '#ccc',
                                        fontSize: '16px',
                                        margin: '10px 0'
                                    }}>
                                        Válido hasta: {new Date(campaignData.campaign.active_until).toLocaleDateString('es-ES')}
                                    </p>
                                )}
                            </div>
                        </>
                    )}

                    {this.renderResults()}

                    {results_product.length === 0 && !this.state.isLoading && (
                        <div className="text-center" style={{color: '#fff', padding: '50px'}}>
                            <h4>No hay productos disponibles en esta campaña</h4>
                            <Link to={`${process.env.PUBLIC_URL}/welcome`} className="btn btn-solid mt-3">
                                Volver al inicio
                            </Link>
                        </div>
                    )}
                </div>

                <div id="addCart-overlay" className="ver-modal-overlay addCart-overlay">
                    <div>
                        <span className="closebtn" onClick={this.closeAddCartCorrectly} title="Close Overlay">×</span>
                        <div className="overlay-content options-overlay-content">
                            <div className="container">
                                <div style={{marginBottom: '2.5rem'}}>
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/icon/add_message.png`} className="img-fluid" alt="" style={{display: 'block',margin: '0 auto'}}/>
                                </div>
                                <div>
                                    <label className="logout-text1">SE AGREGÓ EL PRODUCTO AL CARRITO</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cartItems: state.cartList.cart,
    symbol: state.data.symbol
})

export default connect(mapStateToProps, {addToCart}) (CampaignView);
